var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    stroke: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 11.6425H17.2075C15.43 11.6425 13.9825 10.195 13.9825 8.4175V6.25C13.9825 5.8375 13.645 5.5 13.2325 5.5H10.0525C7.7425 5.5 5.875 7 5.875 9.6775V16.3225C5.875 19 7.7425 20.5 10.0525 20.5H15.9475C18.2575 20.5 20.125 19 20.125 16.3225V12.3925C20.125 11.98 19.7875 11.6425 19.375 11.6425ZM12.6475 14.1475C12.535 14.26 12.3925 14.3125 12.25 14.3125C12.1075 14.3125 11.965 14.26 11.8525 14.1475L11.3125 13.6075V16.75C11.3125 17.0575 11.0575 17.3125 10.75 17.3125C10.4425 17.3125 10.1875 17.0575 10.1875 16.75V13.6075L9.6475 14.1475C9.43 14.365 9.07 14.365 8.8525 14.1475C8.74789 14.0416 8.68922 13.8988 8.68922 13.75C8.68922 13.6012 8.74789 13.4584 8.8525 13.3525L10.3525 11.8525C10.405 11.8075 10.4575 11.77 10.5175 11.74C10.5325 11.7325 10.555 11.725 10.57 11.7175C10.615 11.7025 10.66 11.695 10.7125 11.6875H10.7725C10.8325 11.6875 10.8925 11.7025 10.9525 11.725H10.9675C11.0275 11.7475 11.0875 11.7925 11.1325 11.8375C11.14 11.845 11.1475 11.845 11.1475 11.8525L12.6475 13.3525C12.865 13.57 12.865 13.93 12.6475 14.1475Z",
    fill: "#1390E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 10.6079C17.7848 10.6154 18.7748 10.6154 19.6223 10.6154C20.0498 10.6154 20.2748 10.1129 19.9748 9.81286C18.8948 8.72536 16.9598 6.76786 15.8498 5.65786C15.5423 5.35036 15.0098 5.56036 15.0098 5.98786V8.60536C15.0098 9.70036 15.9398 10.6079 17.0723 10.6079Z",
    fill: "#1390E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.93caca843919ee37539e2923bf9ef1a1.svg";
export { ForwardRef as ReactComponent };